<template>
  <div>
    <form class="form">
      <register-title class="form__title">{{
        $t("owner info")
      }}</register-title>

      <div class="row" v-if="form.length > 0">
        <div
          class="col-xs-12"
          v-for="(owner, owner_index) in form"
          :key="`${owner_index}-operation-country`"
        >
          <div class="rep_minimize" style="margin-top:0px; padding: 15px;">
            <div class="row bottom-xs">
              <div class="col-xs-12">
                <h2>{{ owner.percentage }} %</h2>
                <div
                  class="progress"
                  :style="{ width: `${owner.percentage}%` }"
                ></div>
              </div>
              <div class="col-xs-12 col-sm-8">
                <strong style="font-style: italic">
                  {{ owner.full_name }}
                </strong>
              </div>
              <div class="col-xs-12 col-sm-4 end-xs">
                <p
                  style="opacity: 0.7"
                  @click="deleteCountryOperation(owner.id)"
                >
                  {{ $t("delete") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <hr class="horizontal-line" />
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <register-input
            v-model="form_exact.full_name"
            componentID="full_name"
            inputType="text"
            :label="$t('full name')"
            :inputPlaceholder="$t('full name')"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form_exact.type_of_entity"
            componentID="full_name"
            inputType="text"
            :label="$t('organization form')"
            :inputPlaceholder="$t('organization form')"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form_exact.address_registration"
            componentID="full_name"
            inputType="text"
            :label="$t('register address')"
            :inputPlaceholder="$t('register address')"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form_exact.address_business"
            componentID="full_name"
            inputType="text"
            :label="$t('location address')"
            :inputPlaceholder="$t('location address')"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form_exact.percentage"
            componentID="full_name"
            inputType="number"
            :label="
              $t('share') +
                ` (` +
                $t('from') +
                ` ` +
                `0.00% -` +
                ` ` +
                $t('to') +
                ` ` +
                `${100 - series}%)`
            "
            :inputPlaceholder="$t('share')"
            :isRequired="true"
            :steps="0.1"
            :min_max_number="{
              min: 0,
              max: 100
            }"
            class="form__input"
          />
        </div>
        <div class="col-xs-12" @click="addOwnerData">
          <div class="pane-list-add" style="float: left !important;">
            <p>
              {{ $t("add") }} <b>{{ $t("info").toLowerCase() }}</b>
            </p>
          </div>
        </div>
      </div>
      <div class="row"></div>
      <!--------------------------------------------------------   BIK SERIES   ----->
      <hr class="horizontal-line" />
      <button class="button form__button" @click="nextStep">
        {{ $t("next") }}
      </button>
    </form>
  </div>
</template>
<style>
.progress {
  min-width: 0%;
  border: 2px solid #1a75e9;
  border-radius: 3px;
  margin: 10px 0px;
}
</style>
<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";
export default {
  props: ["user_profile"],
  name: "MainRegForm",
  data() {
    return {
      options: {
        pie: {
          donut: {
            labels: null,
            size: 100
          }
        }
      },
      form: [],
      old_form_exact: {},
      form_exact: {
        full_name: "",
        type_of_entity: "",
        address_registration: "",
        address_business: "",
        percentage: 0
      }
    };
  },
  mixins: [regFormMixin],
  computed: {
    series() {
      let sum = 0;
      let series = [];
      if (this.form.length > 0) {
        this.form.map(owner => {
          sum += owner.percentage;
          series.push(owner.percentage);
        });
        // if (sum < 100) {
        //   series.push(100 - sum);
        // }
      }
      return sum;
    }
  },
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  methods: {
    addOwnerData() {
      let errors = Object.entries(this.form_exact).map(key => {
        if (!this.form_exact[key[0]]) {
          // console.log(key);
          return 1;
        } else {
          return 0;
        }
      });
      // console.log(errors);
      if (errors.includes(1)) {
        this.$toasted.show(this.$t("fill form"));
      } else {
        if (
          this.form_exact.percentage > 0 &&
          this.form_exact.percentage <= 100 - this.series
        ) {
          console.log(
            typeof this.form_exact.percentage,
            this.form_exact.percentage
          );
          this.form_exact.percentage = parseFloat(this.form_exact.percentage);
          this.saveData();
          // this.form.push(JSON.parse(JSON.stringify(this.form_exact)));
        } else {
          this.$toasted.show(
            this.$t("cannot be lower '0%' or higher") +
              `'${100 - this.series}%"`
          );
        }
      }
    },
    deleteCountryOperation(id) {
      FhsAxios.post(`profile/owner/${id}/delete`).then(res => {
        if (res.data.status) {
          this.fetchForm();
        } else {
          this.$toasted.error(this.$t("deleting error"));
        }
      });
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        FhsAxios.get("profile/owners").then(res => {
          if (res.data.status) {
            this.form = res.data.result;
          }
        });
      } catch (e) {
        console.log(e);
        // ERROR HANDLER
      }
    },
    nextStep() {
      this.$router.push({ name: "legal-control-list" });
    },
    saveData() {
      let url = `profile/owner`;
      const form = JSON.parse(JSON.stringify(this.form_exact));
      FhsAxios.post(url, form).then(res => {
        if (res.data.status) {
          this.form_exact.full_name = "";
          this.form_exact.type_of_entity = "";
          this.form_exact.address_registration = "";
          this.form_exact.address_business = "";
          this.form_exact.percentage = 0;
          this.fetchForm();
          this.$toasted.success(this.$t("data saved"));
          return;
        }
        this.$toasted.error(this.$t("error"));
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.saveData();
      }
    }
  },
  mounted() {
    this.fetchForm();
  }
};
</script>
